export function SuperAdminUsersPage() {
  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <h1 className="h4 mb-0">Super Admin · User management</h1>
          <p className="text-muted mb-0">
            Next: port `super_admin/templates/super_admin/user_management.html`.
          </p>
        </div>
      </div>
    </div>
  );
}

